import { log } from './logger';
export function interceptRecoveryToken(): boolean {
  const hash = window.location.hash;

  if (!hash || !hash.includes('type=recovery')) {
    return false;
  }

  log.debug('[RECOVERY-INTERCEPTOR] Recovery token detected in URL hash');

  const hashParams = new URLSearchParams(hash.substring(1));
  const type = hashParams.get('type');
  const accessToken = hashParams.get('access_token');
  const refreshToken = hashParams.get('refresh_token');

  if (type === 'recovery' && accessToken && refreshToken) {
    log.debug('[RECOVERY-INTERCEPTOR] Valid recovery tokens found, redirecting to callback');

    const callbackUrl = new URL('/auth/callback', window.location.origin);
    callbackUrl.searchParams.set('access_token', accessToken);
    callbackUrl.searchParams.set('refresh_token', refreshToken);
    callbackUrl.searchParams.set('type', 'recovery');
    callbackUrl.searchParams.set('token_type', 'bearer');

    window.location.replace(callbackUrl.toString());
    return true;
  }

  log.warn('[RECOVERY-INTERCEPTOR] Recovery type detected but tokens missing');
  return false;
}
